export const ORDER = 'order';

export const ORDER_SYNC = ORDER + '.sync';
export const ORDER_SYNC_CONFIG = ORDER_SYNC + '.config';
